import React from 'react'
import { Link } from 'react-router-dom'
import { formatToTimeZone } from 'date-fns-timezone'
import SimpleBar from 'simplebar-react'

import 'simplebar/dist/simplebar.min.css'
import styles from './Anime.module.scss'
import CountdownTime from '../../containers/CountdownTime'
import LinkIcon from '../LinkIcon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Anime = ({
  title: { english, romaji, native },
  genres,
  coverImage,
  studios: { nodes: studios },
  source,
  episodes,
  duration,
  description,
  idMal,
  viewWidth,
  nextAiringEpisode,
  airingSchedule: { nodes },
  format: type,
  externalLinks,
  trailer,
  startDate,
}) => {
  let titleFontSize,
    studioFontSize,
    tagFontSize,
    tagLineHeight,
    dateFontSize,
    nativeTitleFontSize

  const title = english ? english : romaji

  const renderStudios =
    studios.length > 0
      ? studios.map((studio, i) => {
          if (i !== studios.length - 1) {
            return (
              <li key={studio.name} className={styles.PluralStudios}>
                {studio.name}
              </li>
            )
          } else return <li key={studio.name}>{studio.name}</li>
        })
      : '?'

  /*const splitDescription = description
    ? description.split(/(\(Source: .+\))|(\[Written by .+\])/g)
    : ''*/

  const renderGenres =
    genres.length > 0
      ? genres.map((genre, i) => {
          if (i !== genres.length - 1)
            return (
              <li key={genre} className={styles.PluralGenres}>
                <Link to={`/list/genres/${genre}/TV/1`}>{genre}</Link>
              </li>
            )
          else
            return (
              <li key={genre}>
                <Link to={`/list/genres/${genre}/TV/1`}>{genre}</Link>
              </li>
            )
        })
      : '?'

  const trailerLink = trailer
    ? {
        url:
          trailer.site === 'youtube'
            ? `https://www.youtube.com/watch?v=${trailer.id}`
            : trailer.site === 'dailymotion'
              ? `https://www.dailymotion.com/video/${trailer.id}`
              : '',
        site: trailer.site.replace(/^\w/, c => c.toUpperCase()),
      }
    : ''

  // Handle responsive font-size based on viewwidth

  titleFontSize =
    title.length > 50 ? '.74vw' : title.length > 40 ? '15px' : '12px'

  nativeTitleFontSize = native
    ? native.length > 35
      ? '.62vw'
      : '.9vw'
    : '.9vw'

  tagFontSize =
    genres.length >= 7
      ? '13px'
      : genres.length >= 6
        ? '13px'
        : genres.length >= 5
          ? '13px'
          : '14px'

  tagLineHeight = genres.length >= 6 ? '1.95' : '10px'

  studioFontSize = studios.length >= 3 ? '.6vw' : '.88vw'

  dateFontSize = '.81vw'

  if (viewWidth <= 1550) {
    titleFontSize =
      title.length > 50 ? '15px' : title.length > 40 ? '15px' : '15px'
    dateFontSize = '.75vw'
    studioFontSize = studios.length >= 3 ? '.7vw' : '.8vw'
    nativeTitleFontSize = native
      ? native.length > 50
        ? '.8vw'
        : '1vw'
      : '12px'
    tagFontSize = genres.length >= 5 ? '13px' : '1vw'
  }

  if (viewWidth <= 1472) {
    titleFontSize =
      title.length > 50 ? '15px' : title.length > 40 ? '15px' : '15px'
    nativeTitleFontSize = '12px'
    tagFontSize =
      genres.length >= 8
        ? '13px'
        : genres.length >= 7
          ? '13px'
          : genres.length >= 6
            ? '13px'
            : '13px'

    studioFontSize = studios.length >= 3 ? '.93vw' : '12px'
    dateFontSize = '12px'
  }

  if (viewWidth < 1200) {
    titleFontSize = title.length > 50 ? '1.45vw' : '12px'

    nativeTitleFontSize = '1.35vw'

    tagFontSize =
      genres.length >= 8
        ? '1.05vw'
        : genres.length >= 7
          ? '1.12vw'
          : genres.length >= 6
            ? '1.12vw'
            : '10px'
    studioFontSize = '10px'
    dateFontSize = '10px'
  }

  if (viewWidth < 930) {
    titleFontSize =
      title.length > 50 ? '10px' : title.length > 30 ? '10px' : '10px'
    nativeTitleFontSize = '1.65vw'
    tagFontSize = genres.length >= 6 ? '6px' : '7px'
    if (studios.length >= 3) studioFontSize = '6px'
  }

  return (
    <article className={styles.AnimeContainer}>
      <div className={styles.AnimeCard}>
      <CountdownTime
            time={nextAiringEpisode ? nextAiringEpisode.timeUntilAiring : null}
            ep={nextAiringEpisode ? nextAiringEpisode.episode : null}
            type={type}
          />
      <div className={styles.PosterContainer}>
          <img src={coverImage.large} alt={title} />
        </div>
        <a
          className={styles.MainTitle}
          style={{ fontSize: titleFontSize }}
          href={`https://myanimelist.net/anime/${idMal}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </a>
        <h4
          className={styles.NativeTitle}
          style={{ fontSize: nativeTitleFontSize }}
        >
          {native ? native : english ? english : romaji}
        </h4>
        <ol
          className={styles.AnimeGenres}
          style={{ fontSize: tagFontSize, lineHeight: tagLineHeight }}
        >
          {renderGenres}
        </ol>
        
        
        <div className={styles.AnimeInfo}>
          <ul
            className={styles.AnimeStudios}
            style={{ fontSize: studioFontSize }}
          ><FontAwesomeIcon icon="broadcast-tower" />
            {renderStudios}
          </ul>
          <div className={styles.AnimeDate} style={{ fontSize: dateFontSize }}>
          <FontAwesomeIcon icon="clock" />
            {nodes.length > 0
              ? formatToTimeZone(
                  nodes[0].airingAt * 1000,
                  'D MMM, YYYY [at] HH:mm A z',
                  {
                    timeZone: 'Asia/Kolkata',
                  }
                )
              : startDate
                ? formatToTimeZone(
                    new Date(startDate.year, startDate.month, startDate.day),
                    'Do MMM, YYYY',
                    { timeZone: 'Asia/Kolkata' }
                  )
                : '?'}
          </div>
          <div className={styles.AnimeMetaData}>
            {/*<div className={styles.AnimeSource}>
              {type
                ? type
                    .toLowerCase()
                    .split('_')
                    .join(' ')
                : '?'}
            </div>*/}
            <div className={styles.AnimeEpisodes}>
              {episodes ? episodes : '?'} Episode
              {'  ×  '}
              {duration ? duration : '?'} Min
            </div>
          </div>
          {/*<div className={styles.AnimeDescription}>
              <p
                dangerouslySetInnerHTML={{
                  __html: splitDescription[0] || 'No description found.',
                }}
              />
              <p>{splitDescription[1] || splitDescription[2] || ''}</p>

          </div>*/}
        </div>
        <SimpleBar>
        <div className={styles.ExternalLinks}>
          {externalLinks.length > 0 ? (
            [trailerLink]
              .concat(externalLinks)
              .map(
                link => (link ? <LinkIcon key={link.url} {...link} /> : null)
              )
          ) : (
            <p>?</p>
          )}
        </div>
        </SimpleBar>
      </div>
    </article>
  )
}

export default Anime
